import type { ReactNode } from 'react'

/** Kleine Stroke-Icons (24er-Viewbox), portiert aus dem UX-Dummy. */
function Svg({ children, sw = 2 }: { children: ReactNode; sw?: number }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">
      {children}
    </svg>
  )
}

export type IconKey =
  | 'dash'
  | 'brand'
  | 'users'
  | 'card'
  | 'back'
  | 'plus'
  | 'id'
  | 'mail'
  | 'phone'
  | 'mobile'
  | 'chat'
  | 'fb'
  | 'in'
  | 'web'
  | 'google'
  | 'pin'
  | 'clock'
  | 'toggle'
  | 'eye'
  | 'user1'
  | 'edit'
  | 'lock'
  | 'domains'
  | 'go'

export const Icons: Record<IconKey, ReactNode> = {
  dash: (
    <Svg>
      <rect x="3" y="3" width="7" height="9" />
      <rect x="14" y="3" width="7" height="5" />
      <rect x="14" y="12" width="7" height="9" />
      <rect x="3" y="16" width="7" height="5" />
    </Svg>
  ),
  brand: (
    <Svg>
      <path d="M3 9l9-6 9 6v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <path d="M9 21V12h6v9" />
    </Svg>
  ),
  users: (
    <Svg>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20c.6-3.2 2.9-5 5.5-5s4.9 1.8 5.5 5" />
      <path d="M17 8.2a3 3 0 0 1 0 5.6M18.5 20c-.3-1.8-1-3.2-2-4.2" />
    </Svg>
  ),
  card: (
    <Svg>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8.5" cy="11" r="2" />
      <path d="M13 9h5M13 13h5M5 16h8" />
    </Svg>
  ),
  back: (
    <Svg>
      <path d="M15 18l-6-6 6-6" />
    </Svg>
  ),
  go: (
    <Svg>
      <path d="M9 6l6 6-6 6" />
    </Svg>
  ),
  plus: (
    <Svg sw={2.2}>
      <path d="M12 5v14M5 12h14" />
    </Svg>
  ),
  id: (
    <Svg>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="9" cy="10" r="2.2" />
      <path d="M5.5 16c.5-1.6 1.9-2.4 3.5-2.4s3 .8 3.5 2.4M15 9h4M15 13h4" />
    </Svg>
  ),
  mail: (
    <Svg>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </Svg>
  ),
  phone: (
    <Svg>
      <path d="M4 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L18 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 4 6a2 2 0 0 1 0-2z" />
    </Svg>
  ),
  mobile: (
    <Svg>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M11 18h2" />
    </Svg>
  ),
  chat: (
    <Svg>
      <path d="M21 12a8 8 0 0 1-11.5 7.2L4 20l1-4.8A8 8 0 1 1 21 12z" />
    </Svg>
  ),
  fb: (
    <Svg>
      <path d="M15 3h-2a4 4 0 0 0-4 4v3H6v4h3v7h4v-7h3l1-4h-4V7a1 1 0 0 1 1-1h2z" />
    </Svg>
  ),
  in: (
    <Svg>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M7 10v7M7 7v.01M11 17v-4a2 2 0 0 1 4 0v4" />
    </Svg>
  ),
  web: (
    <Svg>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
    </Svg>
  ),
  google: (
    <Svg>
      <path d="M12 11v3h4.5a5 5 0 1 1-1.4-5.5" />
      <path d="M21 11h-9" />
    </Svg>
  ),
  pin: (
    <Svg>
      <path d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </Svg>
  ),
  clock: (
    <Svg>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </Svg>
  ),
  toggle: (
    <Svg>
      <circle cx="12" cy="12" r="9" />
      <path d="M9 12l2 2 4-4" />
    </Svg>
  ),
  eye: (
    <Svg>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </Svg>
  ),
  user1: (
    <Svg>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c.7-3.6 3.4-5.5 7-5.5s6.3 1.9 7 5.5" />
    </Svg>
  ),
  edit: (
    <Svg>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
    </Svg>
  ),
  lock: (
    <Svg>
      <rect x="4" y="11" width="16" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </Svg>
  ),
  domains: (
    <Svg>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
    </Svg>
  ),
}
